import { render } from "./AssignAgentForm.vue?vue&type=template&id=6eb0d172&lang=pug"
import script from "./AssignAgentForm.vue?vue&type=script&lang=js"
export * from "./AssignAgentForm.vue?vue&type=script&lang=js"

import "./AssignAgentForm.vue?vue&type=style&index=0&id=6eb0d172&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__